import Styled from 'styled-components';

import { media } from '../../../../lib/StyledComponents';

export const VerTaskTitle = Styled.div`
  flex-direction: column;
  align-items: flex-start;
  display: flex;

  ${media.small`
    flex-direction: row;
    align-items: center;
  `}
`;
